import { render, staticRenderFns } from "./MemberDayConfig.vue?vue&type=template&id=08d8ffde&scoped=true"
import script from "./MemberDayConfig.vue?vue&type=script&lang=js"
export * from "./MemberDayConfig.vue?vue&type=script&lang=js"
import style0 from "./MemberDayConfig.vue?vue&type=style&index=0&id=08d8ffde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8ffde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d8ffde')) {
      api.createRecord('08d8ffde', component.options)
    } else {
      api.reload('08d8ffde', component.options)
    }
    module.hot.accept("./MemberDayConfig.vue?vue&type=template&id=08d8ffde&scoped=true", function () {
      api.rerender('08d8ffde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/memberDay/MemberDayConfig.vue"
export default component.exports